import { render, staticRenderFns } from "./addBusinessFunction.vue?vue&type=template&id=015dea7b&scoped=true"
import script from "./addBusinessFunction.vue?vue&type=script&lang=js"
export * from "./addBusinessFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015dea7b",
  null
  
)

export default component.exports